var map = {
	"./malvie1.jpg": 574,
	"./malvie2.jpg": 7294,
	"./malvie3.jpg": 1116,
	"./malvie4.jpg": 9578,
	"assets/collections/editorials/malvie/malvie1.jpg": 574,
	"assets/collections/editorials/malvie/malvie2.jpg": 7294,
	"assets/collections/editorials/malvie/malvie3.jpg": 1116,
	"assets/collections/editorials/malvie/malvie4.jpg": 9578
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5236;